import { useState } from "react";
import { useApp } from "../context/AppContext";

export default function TzView() {
  const { activeId, proj, apiFetch, t, dark, card, btnP, btnSm, flash, inp } = useApp();
  const [tab, setTab] = useState("robots");
  const [url, setUrl] = useState(proj?.domain || "");
  const [cms, setCms] = useState("");
  const [loading, setLoading] = useState(false);
  const [robotsTxt, setRobotsTxt] = useState("");

  const generate = async () => {
    if (!url) { flash("Введіть URL"); return; }
    setLoading(true);
    setRobotsTxt("");
    try {
      const r = await apiFetch(`/api/projects/${activeId}/tz/robots-gen`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ url, cms, language: proj?.lang || "uk" }),
      });
      const d = await r.json();
      if (d.error) { flash("Помилка: " + d.error); }
      else { setRobotsTxt(d.robotsTxt); flash("✓ Згенеровано"); }
    } catch (e) { flash("Помилка: " + e.message); }
    setLoading(false);
  };

  const download = () => {
    const blob = new Blob([robotsTxt], { type: "text/plain;charset=utf-8" });
    const a = document.createElement("a");
    a.href = URL.createObjectURL(blob);
    a.download = "robots.txt";
    a.click();
  };

  return (
    <div style={{ padding: "8px 0" }}>
      <h2 style={{ fontSize: 18, fontWeight: 700, marginBottom: 14 }}>📋 ТЗ на 18</h2>

      <div style={{ display: "flex", gap: 6, marginBottom: 14 }}>
        <button onClick={() => setTab("robots")}
          style={{ padding: "6px 14px", borderRadius: 8, border: "none", cursor: "pointer", fontSize: 13, fontWeight: 600,
            background: tab === "robots" ? "#6366f1" : (dark ? "rgba(255,255,255,0.06)" : "rgba(0,0,0,0.04)"),
            color: tab === "robots" ? "#fff" : t.text }}>
          🤖 robots.txt
        </button>
      </div>

      {tab === "robots" && (
        <div style={{ ...card, padding: 18 }}>
          <div style={{ marginBottom: 8, fontSize: 12, color: t.textMuted }}>
            Генерує оптимальний robots.txt для сайту з урахуванням AEO 2026 (AI-search дозволено, AI-training заблоковано).
          </div>
          <div style={{ display: "grid", gridTemplateColumns: "1fr 200px", gap: 8, marginBottom: 12 }}>
            <input value={url} onChange={e => setUrl(e.target.value)} placeholder="URL сайту (https://example.com)"
              style={{ ...inp, fontSize: 13 }} />
            <input value={cms} onChange={e => setCms(e.target.value)} placeholder="CMS (WordPress, Shopify...)"
              style={{ ...inp, fontSize: 13 }} />
          </div>
          <button onClick={generate} disabled={loading} style={{ ...btnP, fontSize: 13 }}>
            {loading ? "⏳ Генерую..." : "🤖 Згенерувати robots.txt"}
          </button>

          {robotsTxt && (
            <div style={{ marginTop: 16 }}>
              <div style={{ display: "flex", gap: 6, marginBottom: 8 }}>
                <button onClick={() => { navigator.clipboard.writeText(robotsTxt); flash("Скопійовано"); }} style={btnSm}>📋 Копіювати</button>
                <button onClick={download} style={btnSm}>⬇ Завантажити robots.txt</button>
              </div>
              <pre style={{ background: dark ? "rgba(0,0,0,0.3)" : "rgba(0,0,0,0.04)", padding: 12, borderRadius: 8, fontSize: 12, fontFamily: "monospace", whiteSpace: "pre-wrap", maxHeight: 500, overflow: "auto" }}>
                {robotsTxt}
              </pre>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
